/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecurityExpertDto } from '../../models/security-expert-dto';

export interface GetSecurityExpert$Params {

/**
 * the customer id
 */
  customerId: number;
}

export function getSecurityExpert(http: HttpClient, rootUrl: string, params: GetSecurityExpert$Params, context?: HttpContext): Observable<StrictHttpResponse<SecurityExpertDto>> {
  const rb = new RequestBuilder(rootUrl, getSecurityExpert.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SecurityExpertDto>;
    })
  );
}

getSecurityExpert.PATH = '/customers/{customerId}/security-expert';
